/**
 *  超时规则
 * */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './index.module.scss';
import { message, Tooltip } from 'antd';
import { XTitle, XInputNum } from '@/components/xqxc_ui';
import http from '@/assets/api/http';
import PropTypes from 'prop-types';
import model from '@/reducers/system/operatingrule/model';
import { InfoCircleOutlined } from '@ant-design/icons';

class Timeout extends Component {
    state = {
        takeOrdersTm: null,//骑手接单时长-用户发完配送预计
        //骑手到店时长-正常天气
        kilometersGood: null, //公里
        arrivalTimeGood: null, //到店时间
        addMinutesGood: null, //每增加1公里
    };

    componentDidMount() {
        this.props.getTimeoutDetail();
    }

    componentDidUpdate(prevProps) {
        if (this.props.timeoutDetail !== prevProps.timeoutDetail) {
            let { params = {} } = this.props.timeoutDetail;
            const {
                ORDER_TIMEOUT,//骑手接单时长-用户发完配送预计
                PICK_UP_KILOS,//公里
                PICK_UP_TIME,//到店时间
                PICK_UP_PLUS_TIME,//每增加1公里
            } = params;

            this.setState({
                takeOrdersTm: ORDER_TIMEOUT,
                kilometersGood: PICK_UP_KILOS,
                arrivalTimeGood: PICK_UP_TIME,
                addMinutesGood: PICK_UP_PLUS_TIME,
            });
        }
    }


    //保存
    _savehandle = (code, value) => {
        let params = {
            [code]: value
        };
        http('/?cmd=com.xqxc.api.pig.mis.biz.rules.RiderRulesParamService.updateParams', { params }, 'POST').then(() => {
            message.success('保存成功');
        }).catch((e = {}) => {
            message.error(e.message);
        });
    }

    //提示
    renderTips = () => {
        return <div className={styles.pois}>
            <Tooltip title="光标移开触发保存">
                <InfoCircleOutlined />
            </Tooltip>
        </div>;
    }

    render() {
        const { takeOrdersTm, kilometersGood, arrivalTimeGood, addMinutesGood, } = this.state;

        return (
            <div className={styles.flexBoxContainer} style={{ paddingTop: 0 }}>
                <div className={styles.tableContainer} style={{ overflow: 'hidden auto' }}>
                    <XTitle style={{ marginBotton: 5 }} label='骑手接单时长' />
                    <div className={styles.timeoutContent}>
                        <div className={styles.item}>
                            <label>用户发完配送需求后，预计</label>
                            <div className={styles.renderTips}>
                                <XInputNum
                                    inputStyle={{ width: '100px' }}
                                    placeholder='请输入'
                                    precision={0}
                                    min={1}
                                    max={60}
                                    value={takeOrdersTm}
                                    bindThis={this}
                                    bindName='takeOrdersTm'
                                    onBlur={(e) => {
                                        if (!e.target.value) this.setState({ takeOrdersTm: 1 });
                                        this._savehandle('ORDER_TIMEOUT', !e.target.value ? 1 : e.target.value);
                                    }}
                                />
                                {this.renderTips()}
                            </div>
                            <span>分钟内骑士可以接取，超出后用户端配送订单显示为正在为您优先派单。</span>
                        </div>
                    </div>
                    <XTitle style={{ marginBotton: 5 }} label='骑士到取货点时长' />
                    <div className={styles.timeoutContent}>
                        <div className={styles.item}>
                            <div className={styles.renderTips}>
                                <XInputNum
                                    inputStyle={{ width: '100px', }}
                                    placeholder='请输入'
                                    precision={0}
                                    label='正常天气'
                                    min={1}
                                    max={9}
                                    value={kilometersGood}
                                    bindThis={this}
                                    bindName='kilometersGood'
                                    onBlur={(e) => {
                                        if (!e.target.value) this.setState({ kilometersGood: 1 });
                                        this._savehandle('PICK_UP_KILOS', !e.target.value ? 1 : e.target.value);
                                    }}
                                />
                                {this.renderTips()}
                            </div>
                            <div className={styles.renderTips}>
                                <XInputNum
                                    label='公里内，到取货点时间'
                                    inputStyle={{ width: '100px' }}
                                    placeholder='请输入'
                                    precision={0}
                                    min={1}
                                    max={60}
                                    value={arrivalTimeGood}
                                    bindThis={this}
                                    bindName='arrivalTimeGood'
                                    onBlur={(e) => {
                                        if (!e.target.value) this.setState({ arrivalTimeGood: 1 });
                                        this._savehandle('PICK_UP_TIME', !e.target.value ? 1 : e.target.value);
                                    }}
                                />
                                {this.renderTips()}
                            </div>
                            <div className={styles.renderTips}>
                                <XInputNum
                                    label='分钟，每增加1公里增加'
                                    inputStyle={{ width: '100px' }}
                                    placeholder='请输入'
                                    precision={0}
                                    min={1}
                                    max={60}
                                    value={addMinutesGood}
                                    bindThis={this}
                                    bindName='addMinutesGood'
                                    onBlur={(e) => {
                                        if (!e.target.value) this.setState({ addMinutesGood: 1 });
                                        this._savehandle('PICK_UP_PLUS_TIME', !e.target.value ? 1 : e.target.value);
                                    }}
                                />
                                {this.renderTips()}
                            </div>
                            <span>分钟</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Timeout.propTypes = {
    timeoutDetail: PropTypes.object,
    getTimeoutDetail: PropTypes.func,//超时规则数据(action)
};

const mapStateToProps = (state) => ({
    timeoutDetail: state.operatingrule.timeoutDetail,
});

export default connect(mapStateToProps, model.actions)(Timeout);